import { Button, Col, Divider, message, Row, Table, Tag, Typography } from "antd";
import { FaEdit, FaFilePdf, FaTrash } from "react-icons/fa";
import { getColumnSearchProps } from "../../utils";
import { IPlanoGovernoAnexo } from "../../interfaces";
import { memo, useCallback } from "react";
import PlanoGovernoService from "../../../../services/http/services/PlanoGovernoService";

interface ITableAnexo {
  handleCreateOrEditAnexo: (uuid?: string) => void,
  onClickDelete: (uuid: string) => void,
  anexos: IPlanoGovernoAnexo[],
  isLoading: boolean,
  refContagemDoFiltro: React.MutableRefObject<any[]>
}

function TableAnexo({ handleCreateOrEditAnexo, onClickDelete, anexos, isLoading, refContagemDoFiltro }: ITableAnexo) {

  const controller = new AbortController();
  const openArquivo = useCallback((arquivo: string) => {

    let urlPdfAnexo = '';
    const fetchUrl = async () => {
      if (arquivo) {
        try {
          const result = await PlanoGovernoService.getUrlAnexoByArquivo(
            arquivo,
            controller.signal
          );
          urlPdfAnexo = result.arquivo_url;

          const element = document.createElement("a");
          element.href = urlPdfAnexo;
          element.target = '_blank';
          element.click();
        } catch (error) {
          message.error('Erro ao encontrar o arquivo!');
        }
      }
    };

    fetchUrl();
  },[]);


  const columnsAnexo = [
    {
      title: "Nome do anexo",
      dataIndex: "nome",
      key: "nome",
      width: "40%",
      sorter: (a: any, b: any) => a.nome.localeCompare(b.nome),
      ...getColumnSearchProps("nome"),
      showSorterTooltip: false,
    },
    {
      title: "Arquivo",
      dataIndex: "arquivo",
      key: "arquivo",
      width: "25%",
      ...getColumnSearchProps("arquivo"),
      showSorterTooltip: false,
      render: (arquivo: string, record: IPlanoGovernoAnexo) => (
        <span style={{
          display: 'flex',
          flexDirection: 'row'
        }}>
          <Button
            style={{
              borderRadius: 5,
              margin: 1,
              backgroundColor: '#2d9cdb'
            }}
            type="primary"
            size="small"
            onClick={() => openArquivo(arquivo)}
          >
            <FaFilePdf color="" />
          </Button>
          <Divider type="vertical" />
          <h4>{arquivo.split('arquivo-')[1]}</h4>
        </span>
      ),
    },
    {
      title: "Ações",
      dataIndex: "uuid",
      key: "uuid",
      width: "10%",
      render: (uuid: string, record: IPlanoGovernoAnexo) => (
        <span>
          <Button
            style={{
              borderRadius: 5,
              margin: 1,
            }}
            type="primary"
            size="small"
            onClick={() => handleCreateOrEditAnexo(record.uuid)}
          >
            <FaEdit />
          </Button>
          <Divider type="vertical" />
          <Button
            style={{
              borderRadius: 5,
              margin: 1,
            }}
            type="primary"
            danger
            size="small"
            onClick={() => {
              onClickDelete(uuid);
            }}
          >
            <FaTrash />
          </Button>
        </span>
      ),
    },
  ];


  return (<>

    <Row style={{ marginTop: 10, marginBottom: 30 }} gutter={16}>

      <Col
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          type="primary"
          style={{
            backgroundColor: '#15B392'
          }}
          onClick={() => handleCreateOrEditAnexo()}
        >
          <FaEdit />
          Adicionar Anexo
        </Button>
      </Col>
    </Row>
    <Table
      columns={columnsAnexo}
      dataSource={anexos}
      footer={(registros) => {
        return (
          <div
            style={{
              textAlign: "end",
            }}
          >
            <Typography>
              {/* {`Total: ${dadosTabelaState.length} registros.`} */}
              {`Mostrando: ${registros.length
                } de ${refContagemDoFiltro
                  .current.length === 0
                  ? anexos.length
                  : refContagemDoFiltro
                    .current.length
                } num total de ${anexos.length
                } `}
            </Typography>
          </div>
        );
      }}
      scroll={{ x: 700 }}
      pagination={{
        locale: { items_per_page: "" },
        showSizeChanger: true,
        defaultPageSize: 100,
        position: ["bottomRight"],
        pageSizeOptions: ["10", "20", "50", "100"],
      }}
      // rowSelection={rowSelection}
      loading={isLoading}
      rowKey={Math.random}>

    </Table></>)
}

export default memo(TableAnexo);
